// third-party
import { combineReducers, Reducer, AnyAction } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { LOGOUT } from './actions';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
// import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import submissionReducer from './slices/submission';
import tenantReducer from './slices/tenant';
import orderReducer from './slices/order';
import sectionReducer from './slices/section';
import dashboardReducer from './slices/dashboard';
import modalReducer from './slices/modal';
import dataFocusViewReducer from './slices/dataFocusView';

// ==============================|| COMBINE REDUCER ||============================== //

const appReducer = combineReducers({
    section: sectionReducer,
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    // mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    submission: submissionReducer,
    userTenant: tenantReducer,
    createOrder: orderReducer,
    dashboard: dashboardReducer,
    modal: modalReducer,
    dataFocusView: dataFocusViewReducer
});

type AppState = ReturnType<typeof appReducer>;

// Reset all Redux state on LOGOUT so tenant-scoped data does not leak into the
// next session. Preserve `cart` because it is persisted via redux-persist and
// intentionally outlives the auth session.
const reducer: Reducer<AppState, AnyAction> = (state, action) => {
    if (action.type === LOGOUT) {
        const preserved = state ? ({ cart: state.cart } as Partial<AppState>) : undefined;
        return appReducer(preserved as AppState | undefined, action);
    }
    return appReducer(state, action);
};

export default reducer;
